import { Session } from '@supabase/supabase-js';
import { supabase } from '../supabaseClient';

let cachedToken: string | null = null;
let tokenExpiresAt = 0;
let sessionRevision = 0;
let pendingRead: Promise<string | null> | null = null;

const cacheSession = (session: Session | null) => {
  cachedToken = session?.access_token ?? null;
  tokenExpiresAt = (session?.expires_at ?? 0) * 1000;
};

// Keep this callback synchronous: Supabase may invoke it while refreshing
// the session. A completed older read must never restore a signed-out token.
supabase.auth.onAuthStateChange((_event, session) => {
  sessionRevision += 1;
  cacheSession(session);
  pendingRead = null;
});

/** Transport credentials only. The API remains responsible for authorization. */
export const getAccessToken = (): Promise<string | null> => {
  if (cachedToken && tokenExpiresAt > Date.now() + 30_000) {
    return Promise.resolve(cachedToken);
  }
  if (pendingRead) return pendingRead;

  const revision = sessionRevision;
  const read = supabase.auth.getSession().then(({ data, error }) => {
    if (revision === sessionRevision) {
      if (error) throw error;
      cacheSession(data.session);
    }
    return cachedToken;
  }).finally(() => {
    if (pendingRead === read) pendingRead = null;
  });
  pendingRead = read;
  return read;
};
